import { OccMenuParams, SuccessActionPayload } from '@main/categories-menu/const';
import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CATEGORIES_MENU, CategoriesMenuData } from '../categories-menu-state';

export const LOAD_CATEGORIES_MENU = '[Catalog] Categories Menu Load';
export const LOAD_CATEGORIES_MENU_SUCCESS = '[Catalog] Categories Menu Load Success';
export const LOAD_CATEGORIES_MENU_FAIL = '[Catalog] Categories Menu Load Fail';
export const CATEGORIES_MENU_TOGGLE_OPEN = '[Catalog] Categories Menu Toggle Open';
export const CATEGORIES_MENU_SET_STATE = '[Catalog] Categories Menu Set State';
export const CATEGORIES_MENU_CLEAR_STATE = '[Catalog] Categories Menu Clear State';

export class CategoriesMenuLoad extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_CATEGORIES_MENU;

  constructor(public payload: OccMenuParams) {
    super(CATEGORIES_MENU);
  }
}

export class CategoriesMenuLoadFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_CATEGORIES_MENU_FAIL;

  constructor(public payload: any) {
    super(CATEGORIES_MENU, payload);
  }
}

export class CategoriesMenuLoadSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_CATEGORIES_MENU_SUCCESS;

  constructor(public payload: SuccessActionPayload) {
    super(CATEGORIES_MENU);
  }
}

export class CategoriesMenuToggleOpen implements Action {
  readonly type = CATEGORIES_MENU_TOGGLE_OPEN;

  constructor(public payload?: boolean) {}
}

export class CategoriesMenuSetState implements Action {
  readonly type = CATEGORIES_MENU_SET_STATE;

  constructor(public payload: CategoriesMenuData) {}
}

export class CategoriesMenuClearState implements Action {
  readonly type = CATEGORIES_MENU_CLEAR_STATE;
}

export type CategoriesMenuLoadAction = CategoriesMenuLoad | CategoriesMenuLoadFail | CategoriesMenuLoadSuccess;
